import ModalWrapper from '../ModalWrapper'
import '../../styles/prompts.css'
import { getBrushes } from './brushes';

const BRUSHES = getBrushes()
const brushList = Object.values(BRUSHES);

const BrushModal = ({ isOpen, setIsOpen, brush, setBrush }) => {

  const mappedBrushes = brushList.map((b) => (
    <section 
      key={b.id} 
      className="brush-option"
      onClick={() => {
        setBrush({ ...brush, type: b.id })
        setIsOpen(false)
      }}
    >
      <p>[~Brush preview~]</p>
      <h4>{b.name}</h4>
      <input
        type="radio"
        name="brush"
        checked={brush.type === b.id}
        readOnly
      />
    </section>
  ))

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Select Brush"
    >
      <section className="link-container">
        {mappedBrushes}
      </section>
    </ModalWrapper>
  )
}

export default BrushModal